import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.coordinations')
  .service('coordinationsAPI', coordinationsAPI);

/* @ngInject */
function coordinationsAPI(): BringozApi {
  return {
    base: `/coordinations`,
    infiniteScroll: {
      address: `/coordinations`,
      cmd: 'GET'
    },
    actions: {
      getServices: {
        address: 'services',
        cmd: 'GET',
        updateable: false
      },
      updateService: {
        address: 'services/{id}',
        cmd: 'POST',
        updateable: false
      },
      sendAllServicesSMS: {
        address: '{id}/sms',
        cmd: 'POST',
        updateable: false
      },
      declineCoordination: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false
      },
      createAllDeliveries: {
        address: '{id}/delivery',
        cmd: 'POST',
        updateable: false
      },
      sendServiceSMS: {
        address: 'services/sms',
        cmd: 'POST',
        updateable: false
      },
      createDeliveries: {
        address: 'services/delivery',
        cmd: 'POST',
        updateable: false
      },
      declineService: {
        address: 'services',
        cmd: 'DELETE',
        updateable: false
      }
    }
  }
}
